import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { TrendingUp, Package, Users, ShoppingCart, IndianRupee } from "lucide-react";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar } from "recharts";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="p-8 font-display tracking-widest">LOADING...</div>;

  return (
    <div className="p-8" data-testid="admin-dashboard">
      <div className="mb-8">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">CONSOLE / OVERVIEW</div>
        <h1 className="font-display text-5xl tracking-tighter mt-2">DASHBOARD</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
        <StatCard icon={<IndianRupee />} label="REVENUE" value={formatINR(stats.totals.revenue)} />
        <StatCard icon={<ShoppingCart />} label="ORDERS" value={stats.totals.orders} />
        <StatCard icon={<TrendingUp />} label="AOV" value={formatINR(stats.totals.aov)} />
        <StatCard icon={<Users />} label="CUSTOMERS" value={stats.totals.customers} />
        <StatCard icon={<Package />} label="PRODUCTS" value={stats.totals.products} />
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="border border-black/10 bg-white p-6">
          <h3 className="font-display tracking-widest text-xs text-black/60 mb-4">REVENUE — LAST 7 DAYS</h3>
          {stats.revenue_by_day?.length ? (
            <ResponsiveContainer width="100%" height={240}>
              <LineChart data={stats.revenue_by_day.map((d) => ({ day: d._id?.slice(5), rev: d.rev, orders: d.orders }))}>
                <CartesianGrid stroke="#222" strokeDasharray="3 3" />
                <XAxis dataKey="day" stroke="#666" fontSize={11} />
                <YAxis stroke="#666" fontSize={11} />
                <Tooltip contentStyle={{ background: "#000", border: "1px solid #2a2a2a" }} />
                <Line type="monotone" dataKey="rev" stroke="#FF3B30" strokeWidth={2} dot={{ fill: "#FF3B30" }} />
              </LineChart>
            </ResponsiveContainer>
          ) : <div className="text-black/40 py-12 text-center font-mono text-xs">NO DATA YET — PLACE AN ORDER TO SEE TRENDS</div>}
        </div>

        <div className="border border-black/10 bg-white p-6">
          <h3 className="font-display tracking-widest text-xs text-black/60 mb-4">TOP PRODUCTS BY UNITS SOLD</h3>
          {stats.top_products?.length ? (
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={stats.top_products.map((p) => ({ name: p.name?.slice(0, 14), qty: p.qty }))}>
                <CartesianGrid stroke="#222" strokeDasharray="3 3" />
                <XAxis dataKey="name" stroke="#666" fontSize={10} />
                <YAxis stroke="#666" fontSize={11} />
                <Tooltip contentStyle={{ background: "#000", border: "1px solid #2a2a2a" }} />
                <Bar dataKey="qty" fill="#FF3B30" />
              </BarChart>
            </ResponsiveContainer>
          ) : <div className="text-black/40 py-12 text-center font-mono text-xs">NO SALES YET</div>}
        </div>
      </div>
    </div>
  );
}

function StatCard({ icon, label, value }) {
  return (
    <div className="border border-black/10 bg-white p-4">
      <div className="flex items-center justify-between text-[#FF3B30] mb-2">{icon}<span className="font-mono text-[10px] text-black/40">{label}</span></div>
      <div className="font-display text-3xl tracking-tighter">{value}</div>
    </div>
  );
}
